import React, { Component } from "react";
import Chart from "react-apexcharts";

class BarChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chartData: [],
      chartOptions: {},
    };
  }

  componentDidMount() {
    if (this.props.chartData && this.props.chartData.series) {
      this.setState({
        chartData: this.props.chartData.series || [],
        chartOptions: {
          ...this.props.chartOptions,
          xaxis: {
            categories: this.props.chartData.labels || [],
          },
        },
      });
    }
  }
  

  render() {
    return (
      <Chart
        options={this.state.chartOptions}
        series={this.state.chartData}
        type="bar"
        width="100%"
        height="100%"
      />
    );
  }
}

export default BarChart;
